<template>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>PARECER PSICOLÓGICO - Conceito e finalidade</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>&nbsp;Estrutura</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 1º O parecer psicológico deve apresentar as informações da estrutura detalhada abaixo, em&nbsp;forma&nbsp;de&nbsp;itens.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O&nbsp;Parecer&nbsp;é&nbsp;composto&nbsp;de&nbsp;5&nbsp;(cinco)&nbsp;itens:</span></span>
      </p>
    </li>
  </ol>

  <ol style="list-style-type: lower-latin">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; &nbsp; Identificação;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; &nbsp; Descrição&nbsp;da&nbsp;demanda;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; &nbsp; Análise;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; &nbsp; Conclusão;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">&nbsp; &nbsp; &nbsp; &nbsp;Referências.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Identificação</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 2º Neste item, a(o) psicóloga(o) deve fazer constar no documento:&nbsp;</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"
          ><span lang="PT" dir="ltr">Título: <strong>"Parecer&nbsp;Psicológico";</strong></span></span
        >
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome da pessoa ou instituição objeto do questionamento (ou do parecer): identificação do&nbsp;nome completo ou nome social completo e, quando necessário, outras informações sócio-&nbsp;demográficas&nbsp;da&nbsp;pessoa&nbsp;ou&nbsp;instituição&nbsp;cuja&nbsp;dúvida&nbsp;ou&nbsp;questionamento&nbsp;se&nbsp;refere;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome do solicitante: identificação de quem solicitou o documento, especificando se a&nbsp;solicitação foi realizada pelo Poder Judiciário, por empresas, instituições públicas ou privadas,&nbsp;pelo&nbsp;próprio&nbsp;usuário&nbsp;do&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;prestado&nbsp;ou&nbsp;outros&nbsp;interessados;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Finalidade:&nbsp;descrição&nbsp;da&nbsp;razão&nbsp;ou&nbsp;motivo&nbsp;do&nbsp;pedido;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Nome da(o) autora(or): identificação do nome completo ou nome social completo da(o)&nbsp;psicóloga(o) responsável pela construção do documento, com a respectiva inscrição no&nbsp;Conselho Regional de Psicologia e titulação que comprove o conhecimento específico e&nbsp;competência&nbsp;no&nbsp;assunto.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Descrição&nbsp;da&nbsp;Demanda</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 3º Destina-se à transcrição do objetivo da consulta ou demanda. Deve-se apresentar as&nbsp;informações&nbsp;referentes à&nbsp;demanda&nbsp;e finalidades&nbsp;do&nbsp;parecer.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">A&nbsp;descrição&nbsp;da&nbsp;demanda&nbsp;deve&nbsp;justificar&nbsp;a&nbsp;análise&nbsp;realizada.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Análise</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§&nbsp;4º&nbsp;A&nbsp;discussão&nbsp;da&nbsp;questão&nbsp;específica&nbsp;do&nbsp;Parecer&nbsp;Psicológico&nbsp;se&nbsp;constitui&nbsp;na&nbsp;análise&nbsp;minuciosa&nbsp;da questão explanada e argumentada com base nos fundamentos éticos, técnicos e/ou&nbsp;conceituais da &nbsp;Psicologia, bem como nas normativas vigentes que regulam e orientam o&nbsp;exercício&nbsp;profissional.</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Conclusão</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 5º Neste item, a(o) psicóloga(o) apresenta seu posicionamento sobre a questão-problema ou&nbsp;documentos&nbsp;psicológicos&nbsp;questionados.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O documento deve ser encerrado com indicação do local, data de emissão, carimbo, em que&nbsp;conste nome completo ou nome social completo da(o) psicóloga(o), acrescido de sua inscrição&nbsp;profissional, com todas as laudas numeradas, rubricadas da primeira até a penúltima lauda, e a&nbsp;assinatura&nbsp;da(o)&nbsp;psicóloga(o)&nbsp;na&nbsp;última&nbsp;página.</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">É facultado à(ao) psicóloga(o) destacar, ao final do parecer, que este não poderá ser&nbsp;utilizado para fins diferentes do apontado no item de identificação, que possui caráter sigiloso,&nbsp;que se trata de documento extrajudicial e que não se responsabiliza pelo uso dado ao parecer&nbsp;por&nbsp;parte&nbsp;da&nbsp;pessoa,&nbsp;grupo&nbsp;ou&nbsp;instituição,&nbsp;após&nbsp;a&nbsp;sua&nbsp;entrega&nbsp;ao&nbsp;beneficiário,&nbsp;responsável&nbsp;legal&nbsp;e/ou&nbsp;solicitante do&nbsp;serviço&nbsp;prestado.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Referências</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 6º Na elaboração de pareceres psicológicos, é obrigatória a informação das fontes científicas&nbsp;ou&nbsp;referências&nbsp;bibliográficas&nbsp;utilizadas,&nbsp;em&nbsp;nota&nbsp;de&nbsp;rodapé,&nbsp;preferencialmente.</strong></span></span
    >
  </p>
</template>
